"use client";
import {
  createDisclosureStore
} from "./RCQ5P4YE.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
